import { EQUAL_COMPARISION } from 'src/constants/ComponentConstants';
import { WorkflowDetails } from 'src/@types/common';

 const COMMON_FILTERS = [
	 	{
	 		key: 'status',
	 		operators: EQUAL_COMPARISION,
	 		propertyLabel: 'Status',
	 		groupValuesLabel: '',
	 	},
	 	{
	 		key: 'createdBy',
	 		operators: EQUAL_COMPARISION,
	 		propertyLabel: 'Created By',
	 		groupValuesLabel: '',
	 	},
	 	{
	 		key: 'region',
	 		operators: EQUAL_COMPARISION,
	 		propertyLabel: 'Region',
	 		groupValuesLabel: '',
	 	},
	 	{
	 		key: 'cycleId',
	 		operators: EQUAL_COMPARISION,
	 		propertyLabel: 'Cycle ID',
	 		groupValuesLabel: '',
	 	},
		{
	 		key: 'awsRegion',
	 		operators: EQUAL_COMPARISION,
	 		propertyLabel: 'AWS Region',
	 		groupValuesLabel: '',
	 	},
	 ];
	 
export const DEFAULT_WORKFLOW_FILTER_SCHEMA = {
	filters: [
		...COMMON_FILTERS,
		{
			key: 'groupId',
			operators: EQUAL_COMPARISION,
			propertyLabel: 'GroupId / Parent Node Name',
			groupValuesLabel: '',
		},
		{
			key: 'entityName',
			operators: EQUAL_COMPARISION,
			propertyLabel: 'Entity Name',
			groupValuesLabel: '',
		},
	],
};

export const SNOW_WORKFLOW_LIST_WITH_ENTITY_SPECIFIC_SCHEMA: { [key: string]: WorkflowDetails } = {
	ANCHOR_POINT_WORKFLOW: {
		name: 'ANCHOR POINT WORKFLOW',
		groupIdAttributeName: 'Comp parent station code',
		groupIdAttributeId: 'comp_parent_station_code',
		attributeList: [
			{
				id: 'node_display_name',
				name: 'Node Display Name',
			},
		],
		filters: [
			...COMMON_FILTERS,
			{
				key: 'groupId',
				operators: EQUAL_COMPARISION,
				propertyLabel: 'Comp Parent Station Code',
				groupValuesLabel: '',
			},
			{
				key: 'entityName',
				operators: EQUAL_COMPARISION,
				propertyLabel: 'Entity Name',
				groupValuesLabel: '',
			},
		],
	},
	SORTER_SETUP_WORKFLOW: {
		name: 'Sorter Setup Workflow',
		attributeList: [
			{
				id: 'needByDate',
				name: 'Need By Date',
			},
		],
		actionColumn: {
			label: 'Execute',
			urlTemplate: '#/launchSorterWorkflow/execute?name={node_id}',
			conditionalStatus: 'DRAFT',
		},
		filters: [...DEFAULT_WORKFLOW_FILTER_SCHEMA.filters],
	},
	NODE_ADDRESS_UPDATE_WORKFLOW: {
		name: 'Node Address Update Workflow',
		attributeList: [
			{
				id: 'Approver',
				name: 'Approver',
			},
		],
		actionColumn: {
			label: 'View Diff',
			urlTemplate: '#/launchNodeAddressUpdateWorkflowDetails?name={node_id}',
		},
		filters: [...DEFAULT_WORKFLOW_FILTER_SCHEMA.filters],
	},
	FC_RECONFIG_WORKFLOW: {
		name: 'FC Reconfiguration Workflow',
		attributeList: [
			{
				id: 'old_node_properties',
				name: 'Existing Node Properties',
			},
			{
				id: 'node_properties',
				name: 'New Node Properties',
			},
		],
		actionColumn: {
			label: 'View Diff',
			urlTemplate: '#/launchFCReconfigNodeDetails?name={node_id}',
		},
		filters: [...DEFAULT_WORKFLOW_FILTER_SCHEMA.filters],
	},
	'ef4e8cce-c7f1-4a41-b190-75d4008e5bd2': {
		name: 'QC TEZ Setup Workflow',
		attributeList: [],
		actionColumn: {
			label: 'Next Steps',
			urlTemplate: 'https://slate-web-ui.harmony.a2z.com/workflows',
			conditions: [
				{ field: 'workflow_status', value: 'COMPLETED' },
				{ field: 'country', value: 'IN' },
			],
		},
		infoPanel: {
			type: 'info',
			header: 'QC TEZ Setup - Next Steps',
			content: 'Once the QC workflow is complete for the India node, use the "Next Steps" action link to proceed with the dry run tests on the SLATE portal.',
			link: {
				text: 'Go to SLATE Portal',
				href: 'https://slate-web-ui.harmony.a2z.com/workflows',
			},
		},
		filters: [...DEFAULT_WORKFLOW_FILTER_SCHEMA.filters],
	},
	FC_LAUNCH_WORKFLOW: {
		name: 'FC Launch Workflow',
		attributeList: [
			{
				id: 'node_properties',
				name: 'Node Properties',
			},
		],
		filters: [...DEFAULT_WORKFLOW_FILTER_SCHEMA.filters],
	},
	'41f2991b-8cc4-42d4-8a70-c788d09b3ba4': {
		name: 'CARDINAL_FLOOR_READINESS_WORKFLOW',
		groupIdAttributeName: 'FC Name',
		groupIdAttributeId: 'NODE_NAME',
		attributeList: [
			{
				id: 'CHUTE_ID',
				name: 'Chute ID',
			},
		],
		filters: [
			...COMMON_FILTERS,
			{
				key: 'groupId',
				operators: EQUAL_COMPARISION,
				propertyLabel: 'FC Name',
				groupValuesLabel: '',
			},
		],
	},
	'14784848-8b23-4803-a581-a3480b5fae81': {
		name: 'CONFIGURE_MAWS_CNAME_WORKFLOW',
		groupIdAttributeName: 'FC Name',
		groupIdAttributeId: 'NODE_NAME',
		attributeList: [
			{
				id: 'SERVICE_NAME',
				name: 'Service Name',
			},
			{
				id: 'cname',
				name: 'Cname'
			},
			{
				id: 'end_point',
				name: 'Endpoint'
			}
		],
		filters: [
			...COMMON_FILTERS,
			{
				key: 'groupId',
				operators: EQUAL_COMPARISION,
				propertyLabel: 'FC Name',
				groupValuesLabel: '',
			},
		],
	},
	'176eb9a9-18f8-4072-9868-92aea6c4b623': {
		name: 'CONFIGURE_ROUTE53_CNAME_WORKFLOW',
		groupIdAttributeName: 'FC Name',
		groupIdAttributeId: 'NODE_NAME',
		attributeList: [
			{
				id: 'SERVICE_NAME',
				name: 'Service Name',
			},
			{
				id: 'cname',
				name: 'Cname'
			},
			{
				id: 'end_point',
				name: 'Endpoint'
			}
		],
		filters: [
			...COMMON_FILTERS,
			{
				key: 'groupId',
				operators: EQUAL_COMPARISION,
				propertyLabel: 'FC Name',
				groupValuesLabel: '',
			},
		],
	},
};

export function getWorkflowFiltersByName(workflowName: string): WorkflowDetails {
	return SNOW_WORKFLOW_LIST_WITH_ENTITY_SPECIFIC_SCHEMA[workflowName] || DEFAULT_WORKFLOW_FILTER_SCHEMA;
}

export const WORKFLOW_TO_GROUP_ID_ATTRIBUTE_MAP = {};

export const DEFAULT_GROUP_ID_ATTRIBUTE = 'NODE_NAME';

export function getGroupIdByWorkflow(workflowId?: string | null) {
	return WORKFLOW_TO_GROUP_ID_ATTRIBUTE_MAP[workflowId ?? ''] || DEFAULT_GROUP_ID_ATTRIBUTE;
}
